import { api, uitvoeren } from './client.ts';
import { cvSleutels } from './cvs.ts';
import { kandidaatSleutels } from './kandidaten.ts';
import { useApiMutatie } from './mutaties.ts';
import type { CvVerrijking, Kandidaatvoorstel } from './typen.ts';

function formulier(delen: [string, string | File][]): FormData {
  const gegevens = new FormData();
  for (const [naam, waarde] of delen) {
    if (typeof waarde === 'string') {
      gegevens.append(naam, waarde);
    } else {
      gegevens.append(naam, waarde, waarde.name);
    }
  }
  return gegevens;
}

/**
 * Mutaties voor een kandidaat uit een cv: het cv laten uitlezen door AI, en daarna de gecontroleerde kandidaat
 * aanmaken met hetzelfde bestand.
 * @returns De mutaties.
 */
export function useCvIntake() {
  return {
    analyseer: useApiMutatie(
      (bestand: File) =>
        uitvoeren(
          api.POST('/api/v1/cvs/analyse', {
            body: { bestand: bestand as unknown as string },
            bodySerializer: () => formulier([['bestand', bestand]]),
          }),
        ),
      () => [],
    ),
    maakKandidaat: useApiMutatie(
      ({ bestand, gegevens }: { bestand: File; gegevens: Kandidaatvoorstel }) =>
        uitvoeren(
          api.POST('/api/v1/kandidaten/uit-cv', {
            body: { gegevens: JSON.stringify(gegevens), bestand: bestand as unknown as string },
            // Eerst de gegevens, dan het bestand: de API leest de delen op volgorde.
            bodySerializer: () =>
              formulier([
                ['gegevens', JSON.stringify(gegevens)],
                ['bestand', bestand],
              ]),
          }),
        ),
      () => [kandidaatSleutels.alle, cvSleutels.alle],
    ),
    analyseerCv: useApiMutatie(
      (cvId: string) => uitvoeren(api.POST('/api/v1/cvs/{id}/analyse', { params: { path: { id: cvId } } })),
      () => [],
    ),
    verrijk: useApiMutatie(
      ({ cvId, invoer }: { cvId: string; kandidaatId: string; invoer: CvVerrijking }) =>
        uitvoeren(api.POST('/api/v1/cvs/{id}/verrijk', { params: { path: { id: cvId } }, body: invoer })),
      ({ kandidaatId }) => [kandidaatSleutels.profiel(kandidaatId), kandidaatSleutels.alle, cvSleutels.alle],
    ),
  };
}
